import { render, staticRenderFns } from "./SkuFieldsList.vue?vue&type=template&id=ed018714&scoped=true"
import script from "./SkuFieldsList.vue?vue&type=script&lang=js"
export * from "./SkuFieldsList.vue?vue&type=script&lang=js"
import style0 from "./SkuFieldsList.vue?vue&type=style&index=0&id=ed018714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed018714",
  null
  
)

export default component.exports